import { render } from "./RelatedResource.vue?vue&type=template&id=30213156"
import script from "./RelatedResource.vue?vue&type=script&lang=js"
export * from "./RelatedResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__